var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"right-card pt-10 pb-10"},[_c('p',{staticClass:"card-p text-center"},[_vm._v("You selected")]),_c('h3',{staticStyle:{"color":"#069 !important"}},[_vm._v("30-day trial")])])
}
var staticRenderFns = []

export { render, staticRenderFns }